
/* eslint-disable max-lines-per-function */
/* eslint-disable max-depth */
/* eslint-disable complexity */
import { mapState, mapGetters } from 'vuex'
import { Settings } from 'luxon'
import { io } from 'socket.io-client'
import { queueStatus as queueStatusEnum } from '~/enums/queueStatus'
import {
	COOKIE_DISCORD_OAUTH,
	MatchState,
	MAX_TH_LEVEL,
	ROLE_CO_LEADER,
	ROLE_LEADER,
	COOKIE_TOGGLE_TYPE,
} from '~/utils/constants'
import dayjs from 'dayjs'

// Maps hard-linked player tags to the event they should be pinned to
// (overriding the time-based active event). See mocks/lth.js.
import { eventIdByPlayerTag } from '~/mocks/lth'

export default {
	name: 'DefaultLayout',
	// i18n: { messages },
	data: () => ({
		ageCookie: null,
		params: null,
		showCheckins: false,
		matchCheckInterval: null,
		matchCheckInFiveMinutesInterval: null,
		upcomingMatchId: null,
		showStartWarModal: false,
		timeFrameInterval: null,
		middlewareRosterObject: null,
		showMatchFoundModal: false,
		upcomingChallengeId: null,
		matchSocket: null,
		emulatorPayload: null,
	}),
	computed: {
		...mapState(['inApp', 'initialLoading', 'apiToken', 'clanRosterId', 'scToken']),
		...mapState('match', ['shouldCheckin']),
		...mapState('event', ['segments', 'activeEvent', 'activeSegment', 'registrationSegment']),
		...mapState('user', [
			'userId',
			'rosters',
			'latestRoster',
			'middlewareRosterId',
			'initialLoadErrorMessage',
			'queueStatus',
		]),
		...mapState('i18n', ['locale']),
		...mapGetters('user', ['rosterLocked', 'isClanCaptain']),

		showQueueButton() {
			const now = dayjs()
			if (
				!this.activeSegment ||
				!this.activeSegment.date ||
				this.activeSegment.eliminationType !== 'ladder'
			)
				return false
			return (
				this.isClanCaptain &&
				this.rosterLocked &&
				now.isAfter(dayjs(this.activeSegment.date.from)) &&
				now.isBefore(dayjs(this.activeSegment.date.to))
			)
		},
		isNonStandardLanguage() {
			if (this.locale) {
				const nonstandardLocales = ['jp', 'ko', 'zh_cn', 'zh_tw']
				return nonstandardLocales.includes(this.locale.toLowerCase())
			} else {
				return false
			}
		},
		onErrorPage() {
			if (this.$route && this.$route.fullPath) {
				return this.$route.fullPath.includes('/error')
			} else {
				return false
			}
		},

		isLoading() {
			// if user getting back from discord oauth
			const routePath = this.$route.path
			const oAuthCookie = this.$cookies.get(COOKIE_DISCORD_OAUTH)
			if (oAuthCookie) {
				return this.initialLoading
			}

			const isIndexLang = this.$i18n.localeCodes.find((path) =>
				routePath.startsWith(`/${path}`)
			)

			let langPath
			if (isIndexLang) {
				langPath = routePath.replace(`/${isIndexLang}`, '/').replace('//', '/')
			}

			if (routePath === '/' || (langPath && langPath === '/')) {
				return false
			}
			return this.initialLoading
		},
	},
	async mounted() {
		try {
			if (this.$config.inApp !== 'true' && this.$config.inApp !== true) {
				this.$store.commit('setInApp', false)
				this.$store.commit('setApiToken', this.$config.apiSecret)
			}

			if (this.$config.isWfActive === true) {
				this.$store.commit('worldFinals/setIsWfActive', true)
			}

			if (this.$config.isLcqActive === true) {
				this.$store.commit('lcq/setIsLcqActive', true)
			}

			// handle emulator payload
			window.addEventListener('message', (event) => {
				if (event?.data?.platform === 'emulator') {
					this.emulatorPayload = event.data
				}
			})

			await this.$store.dispatch('event/getEvents')
		} catch (err) {
			await this.$logApi.createLogMessage(`SPA nuxtServerInit failed`, {
				error: JSON.stringify(err),
			})
			// eslint-disable-next-line no-console
			console.error('SPA nuxtServerInit failed', err)
		}
		const crURL = 'clashofclans-inbox://getParams'
		let locale = this.locale
		if (this.locale.toLowerCase() === 'zh_cn') {
			locale = 'zh-cn'
		} else if (this.locale.toLowerCase() === 'zh_tw') {
			locale = 'zh-tw'
		} else if (this.locale.toLowerCase() === 'jp') {
			locale = 'ja'
		}
		Settings.defaultLocale = locale

		if (!this.inApp) {
			const platform = 'local'
			const country = 'CA'

			let playerTag = '#2YVRJG' // default playerTag

			if (this.$route.query.playerTag) {
				playerTag = `#${this.$route.query.playerTag}`
			}

			const apitoken = this.apiToken
			const obj = { apitoken, platform, country, playerTag }
			this.initialLoad(obj)
		} else {
			window.location = crURL
			window.setParams = (params) => {
				if (params.apitoken) {
					this.params = JSON.stringify(params)
					this.initialLoad(params)
					return
				}

				if (params.apisecret) {
					this.$store.commit('setApiToken', params.apisecret)
					params.apitoken = this.apiToken
					this.initialLoad(params)
					return
				}

				this.$store.commit('setInitialLoading', false)
			}
		}

		if (this.emulatorPayload && window.setParams) {
			window.setParams(this.emulatorPayload)
		}

		const oAuthCookie = this.$cookies.get(COOKIE_DISCORD_OAUTH)
		if (oAuthCookie) {
			this.$cookies.remove(COOKIE_DISCORD_OAUTH, { path: '/' })
			this.$router.push(
				this.localePath({
					path: '/registration/profile/create',
					query: { discord: 'true' },
				})
			)
		}
		this.$nuxt.$on('left-team', () => {
			if (this.matchCheckInterval) {
				clearInterval(this.matchCheckInterval)
				this.matchCheckInterval = null
			}
		})
	},
	beforeDestroy() {
		if (this.matchCheckInterval) {
			clearInterval(this.matchCheckInterval)
			this.matchCheckInterval = null
		}
		if (this.matchCheckInFiveMinutesInterval) {
			clearInterval(this.matchCheckInFiveMinutesInterval)
			this.matchCheckInFiveMinutesInterval = null
		}
		if (this.timeFrameInterval) {
			clearInterval(this.timeFrameInterval)
			this.timeFrameInterval = null
		}
		this.$nuxt.$off('left-team')
	},
	methods: {
		async checkForQueueStatus() {
			if (!this.activeSegment) {
				return
			}

			try {
				const resp = await this.$api.matches.matchSeries.checkQueueStatus(
					this.activeSegment.id
				)
				const queueStatus = resp?.data

				if (!queueStatus?.id) {
					this.$store.commit('user/setQueueStatus', queueStatusEnum.NONE)
					return
				}

				if (queueStatus.status === queueStatusEnum.ACCEPTED) {
					this.$store.commit('user/setQueueStatus', queueStatusEnum.ACCEPTED)
					return
				}

				if (!['declined', 'expired', 'cancelled'].includes(queueStatus.status)) {
					this.$store.commit('user/setQueueStatus', queueStatusEnum.IN_QUEUE)
					return
				}

				this.$store.commit('user/setQueueStatus', queueStatusEnum.NONE)
			} catch (error) {
				const statusCode = error?.response?.status
				if (statusCode === 404) {
					if (
						this.latestRoster &&
						this.userId &&
						this.latestRoster.owner &&
						this.latestRoster.owner.id === this.userId
					) {
						this.$logApi.createLogMessage(
							`NO QUEUE STATUS FOR PLAYER WITH PLAYERTAG: ${this.playerTag}`
						)
					}
				}
				// eslint-disable-next-line no-console
				console.error(error)
				this.$store.commit('user/setQueueStatus', queueStatusEnum.NONE)
			}
		},
		async checkForPendingMatchups() {
			if (!this.userId) {
				return
			}
			try {
				const resp = await this.$api.matches.matchSeries.getMatchups({
					'filter[user.id]': this.userId,
				})

				const matchup = resp?.data?.data?.[0]
				if (matchup?.status === 'awaiting_confirmation') {
					const TIMEOUT_WINDOW = 15 * 1000
					const now = dayjs()
					const remainingTime = TIMEOUT_WINDOW - now.diff(dayjs(matchup.createdAt))

					// Experimental value. User still has at least 2 seconds to accept/decline the matchup
					if (remainingTime >= 2000) {
						this.upcomingChallengeId = matchup.id
						this.showMatchFoundModal = true
					} else {
						// Not enough time to open the match found modal and have the user take action.
						// The matchup will timeout and the user will get removed from the queue.
						this.$store.commit('user/setQueueStatus', queueStatusEnum.NONE)
					}
				}
			} catch (e) {
				// eslint-disable-next-line no-console
				console.error(e)
			}
		},
		async checkForMatchesInFiveMinuteWindow() {
			if (!this.userId || !this.activeEvent) {
				return
			}
			try {
				// Scope to the roster's event so hard-mapped players (pinned to a
				// hidden event) match their linked match, not the time-based activeEvent.
				const eventId = this.latestRoster?.event?.id || this.activeEvent.id
				const { data: matches } = await this.$api.matches.matchSeries.getAll({
					'filter[user]': this.userId,
					'filter[event]': eventId,
					...(this.latestRoster ? { 'filter[roster]': this.latestRoster.id } : null),
					'filter[state]': MatchState.UPCOMING,
					sort: 'date',
					'page[size]': 1,
					'page[number]': 1,
				})
				if (matches.length > 0) {
					// Check if upcoming match is within the next 5 minutes
					const upcomingMatch = matches[0]
					const now = dayjs()
					const matchTime = dayjs(upcomingMatch.date)
					if (now.isBefore(matchTime)) {
						this.upcomingMatchId = upcomingMatch.id
						this.showStartWarModal = true
						// show modal here
					} else {
						this.showStartWarModal = false
					}
				} else {
					this.showStartWarModal = false
				}
			} catch (e) {
				this.showStartWarModal = false
				// eslint-disable-next-line no-console
				console.error(e)
			}
		},

		socketSetup() {
			this.matchSocket = io(
				`${this.$config.matchSocketUrl}/${this.$config.tenant}/frontend`,
				{
					autoConnect: false,
					transports: ['websocket'],
				}
			)

			this.matchSocket.on('connect', () => {
				this.matchSocket.emit('user', {
					id: this.userId,
				})
			})

			this.matchSocket.on('reconnect', () => {
				this.matchSocket.emit('user', {
					id: this.userId,
				})
			})

			this.matchSocket.on('update', (data) => {
				if (
					data?.event === 'matches:match_up_found' &&
					this.queueStatus === queueStatusEnum.IN_QUEUE
				) {
					this.upcomingChallengeId = data?.data?.id
					this.showMatchFoundModal = true
				}
			})

			this.matchSocket.on('connect_error', (error) => {
				// eslint-disable-next-line no-console
				console.error(error)
				this.$logApi.createLogMessage(`WS connect_error: ${error}`)
			})

			this.matchSocket.on('error', (error) => {
				// eslint-disable-next-line no-console
				console.error(error)
				this.$logApi.createLogMessage(`WS error: ${error}`)
			})
		},

		eventListenerSetup() {
			window.addEventListener('beforeunload', () => {
				if (this.queueStatus === queueStatusEnum.IN_QUEUE)
					this.$api.matches.matchSeries.leaveQueue(this.activeSegment.id)
			})

			document.addEventListener('visibilitychange', () => {
				if (this.showQueueButton && document.visibilityState === 'visible') {
					this.checkForQueueStatus()
					this.checkForPendingMatchups()
				}
			})
		},

		async initialLoad({ apitoken, platform, country, playerTag }) {
			if (!apitoken || !platform || !country || !playerTag) {
				this.$store.commit('setInitialLoading', false)
				return
			}

			this.$store.commit('setPlatform', platform)
			this.$store.commit('setCountry', country)
			this.$store.commit('setPlayerTag', playerTag)

			this.$loadCountrySettings()
			this.socketSetup()
			this.eventListenerSetup()

			try {
				// Registration overlaps with MF, so for specific players from the
				// past LTH event we need to load the old (preseason) event based on
				// the playerTag instead of the time-based active event.
				const mappedEventId = eventIdByPlayerTag[playerTag]
				if (mappedEventId) {
					await this.$store.dispatch('event/getEvents', mappedEventId)
				}

				const userRes = await this.$scApi.getUser(apitoken, playerTag)

				if (userRes?.data?.data) {
					const { data: resData } = userRes
					const { data } = resData

					const token = data.attributes.token
					const userId = data.id
					const user = data.user

					const scToken = resData.token
					const clan = resData.clan
					const isLeader = resData.isLeader
					const userThLevel = resData.thLevel
					const clanThLevel = clan?.thLevel || userThLevel || MAX_TH_LEVEL
					const middlewareRosterId = resData.rosterId
					const isCoLeader = resData.role === ROLE_CO_LEADER

					// this user already exists, remove the signup cookies
					this.$store.dispatch('cookies/removeCookiesSignup')

					// Set the user data
					this.$store.commit('setScToken', scToken)
					this.$store.commit('user/setUserId', userId)
					this.$store.commit('user/setUsThLevel', userThLevel)
					this.$store.commit('user/setToken', token)
					this.$store.commit('user/setClan', clan)
					this.$store.commit('user/setIsLeader', isLeader)
					this.$store.commit('user/setIsCoLeader', isCoLeader)
					this.$store.commit('user/setUser', user)
					this.$store.commit('user/setMiddlewareRosterId', middlewareRosterId)

					this.$api.setBearerToken({ value: token })

					if (this.matchSocket?.disconnected) {
						this.matchSocket.connect()
					}

					if (!this.activeEvent) {
						return
					}

					await this.$store.dispatch('user/getRoster', {
						eventId: this.activeEvent.id,
						userId,
						middlewareRosterId,
					})

					this.$store.dispatch('event/setActiveSegmentForEvent', clanThLevel)
					if (!this.$cookies.get(COOKIE_TOGGLE_TYPE)) {
						this.$setCookieDefaultHomeTab({ thLevel: clanThLevel })
					}

					const isLadder = this.activeSegment?.eliminationType === 'ladder'
					const isCaptain = this.latestRoster?.owner?.id === userId

					if (this.latestRoster && isLadder) {
						this.checkForQueueStatus()
						this.checkForPendingMatchups()
					}

					if (this.latestRoster && !isLadder) {
						if (!this.matchCheckInterval && isCaptain) {
							this.$store.dispatch('match/checkForUpcomingMatch')
							this.matchCheckInterval = setInterval(() => {
								this.$store.dispatch('match/checkForUpcomingMatch')
							}, 10000)
						}
					} else if (this.latestRoster && isLadder) {
						if (!this.matchCheckInFiveMinutesInterval && isCaptain) {
							this.checkForMatchesInFiveMinuteWindow()
							this.matchCheckInFiveMinutesInterval = setInterval(() => {
								this.checkForMatchesInFiveMinuteWindow()
							}, 60000)
						}
					}
				}
			} catch (err) {
				// eslint-disable-next-line no-console
				console.error(err)
				const statusCode = err?.response?.status

				// No v3 user found
				if (statusCode === 404) {
					const { data } = err.response

					const isLeader = data.isLeader
					const isCoLeader = data.role === ROLE_CO_LEADER
					const clan = data.clan
					const userThLevel = data.thLevel
					const clanThLevel = clan?.thLevel || userThLevel || MAX_TH_LEVEL
					const middlewareRosterId = data.rosterId
					const scToken = data.token

					if (scToken) {
						this.$store.commit('setScToken', scToken)
					}

					if (isLeader) {
						this.$store.commit('user/setIsLeader', isLeader)
					}

					if (isCoLeader) {
						this.$store.commit('user/setIsCoLeader', isCoLeader)
					}

					if (clan) {
						this.$store.commit('user/setClan', clan)
					}

					if (userThLevel) {
						this.$store.commit('user/setUsThLevel', userThLevel)
					}

					if (middlewareRosterId) {
						this.$store.commit('user/setMiddlewareRosterId', middlewareRosterId)

						await this.$store.dispatch('user/getRoster', {
							middlewareRosterId,
						})
					}

					this.$store.dispatch('event/setActiveSegmentForEvent', clanThLevel)
					if (!this.$cookies.get(COOKIE_TOGGLE_TYPE)) {
						this.$setCookieDefaultHomeTab({ thLevel: clanThLevel })
					}

					// We have to check for the leader if they are part of the roster or not
					if (isLeader) {
						const clanData = await this.$scApi.getClanMembers(scToken)
						if (clanData?.data?.items?.length) {
							const leaderItem = clanData.data.items.find(
								(i) => i.role === ROLE_LEADER
							)
							if (leaderItem) {
								this.$store.commit(
									'setShowRegistrationButton',
									leaderItem.isRosterMember
								)
							}
						}
					} else {
						this.$store.commit('setShowRegistrationButton', true)
					}
				}
				// user not found in Supercell, or JWT was invalid
				else if (statusCode === 401) {
					const { data: errData } = err.response

					this.$store.dispatch('event/setActiveSegmentForEvent', MAX_TH_LEVEL)
					if (!this.$cookies.get(COOKIE_TOGGLE_TYPE)) {
						this.$setCookieDefaultHomeTab({ thLevel: MAX_TH_LEVEL })
					}

					this.$store.commit('user/setInitialLoadErrorMessage', errData.message)
					this.$store.commit('setShowRegistrationButton', false)
					if (errData.message === 'INSUFFICIENT_TH_LEVEL') {
						this.$store.commit('setThNotHighEnough', true)
					} else if (
						errData.message === 'INSUFFICIENT_ROLE' ||
						errData.message === 'NOT_INVITED'
					) {
						if (errData?.clanRosterId) {
							this.$store.commit('setNotInvited', true)
							this.$store.commit('setClanRosterId', errData.clanRosterId)
							this.$store.commit('setScToken', errData.token)
							this.$store.commit('user/setClan', errData.clan)
						} else if (errData?.clanRosterId === null) {
							this.$store.commit('setNotInvited', false)
							this.$store.commit('setClanRosterId', null)
							this.$store.commit('setScToken', errData.token)
							this.$store.commit('user/setClan', errData.clan)
							this.$store.commit('setClanDidNotCreateRoster', true)
						}
					} else if (errData.message === 'NO_CLAN') {
						// eslint-disable-next-line no-console
						console.error('Player is not part of a clan')
					} else if (errData.message === 'PLAYER_BANNED') {
						// eslint-disable-next-line no-console
						console.error('Player is banned')
					} else {
						await this.$logApi.createLogMessage(`InitialLoad failed`, {
							error: JSON.stringify(err),
						})

						const message = errData.message || 'unknown'
						this.$router.push(`/fatal-error/${encodeURIComponent(message)}`)
					}
				} else {
					this.$router.push(`/fatal-error/${encodeURIComponent(err.message)}`)
				}
			} finally {
				try {
					const isError = ['NO_CLAN', 'INSUFFICIENT_TH_LEVEL', 'PLAYER_BANNED'].includes(
						this.initialLoadErrorMessage
					)

					if (this.scToken && !isError) {
						const membersData = await this.$scApi.getClanMembers(this.scToken)
						if (membersData?.data?.items) {
							this.$store.commit('user/setClanMembers', membersData.data.items)
						}
						if (membersData?.data?.roster) {
							this.$store.commit('user/setClanRoster', membersData.data.roster)
						}
					}
				} catch (error) {
					// eslint-disable-next-line no-console
					console.error(error)
				}

				this.$store.commit('setInitialLoading', false)
				this.$logApi.createLogMessage(`InitialLoad done for playerTag: ${playerTag}`)
			}
		},
		openCheckInModal() {
			this.$root.$emit('openModal', 'test-modal')
		},
	},
}
